module.exports = __webpack_public_path__ + "img/3_ru.a551a3de.webp";